@import "../../../../styles/variables";
:host {
  position: fixed;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% - 32px);
  height: 40px;
  padding: 16px;
  z-index: 99;
  background-color: $svs-white;
  box-shadow: 0 7px 18px -7px rgba(#333333, 0.18);
}

button.result-button {
  display: block;
  background-color: #008a16;
  height: 40px;
  width: 100%;
  padding: 12px 24px;
  color: $svs-white;
  border: none;
  border-radius: 2px;
  font-size: 16px;
  font-weight: 400;

  &[disabled] {
    opacity: 0.4;
  }
}
